import { ComponentProps } from 'react'
import { Box, BoxProps, Flex } from 'theme-ui'
import { Paper, Heading, Text, Button } from 'components'
import { EmptyListIcon } from 'components/Icon'

export type EmptyStateProps = BoxProps & {
  heading: string
  text: string | undefined
  button?: ComponentProps<typeof Button>
  icon?: string
  withPaper?: boolean
}

export function EmptyState({
  heading,
  text,
  button,
  icon = undefined,
  withPaper = true,
  ...rest
}: EmptyStateProps) {
  const Content = () => (
    <Flex sx={{ flexDirection: 'column', alignItems: 'center', p: 4 }}>
      {icon && (
        <Box sx={{ mb: 5 }}>
          <EmptyListIcon />
        </Box>
      )}
      <Heading>{heading}</Heading>
      <Text
        sx={{
          pt: 5,
          pb: 6,
          maxWidth: 300,
          textAlign: 'center',
          color: 'grey',
          fontSize: 2,
          lineHeight: 'body',
        }}>
        {text}
      </Text>
      {button && button}
    </Flex>
  )
  return (
    <Box {...rest}>
      {withPaper && (
        <Paper withShadow>
          <Content />
        </Paper>
      )}

      {!withPaper && <Content />}
    </Box>
  )
}
